"use client";
import Image from "next/image";
import { SwiperOptions } from "swiper/types";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { university_classic_program_data } from "@/data/program-data";
import Link from "next/link";
import { getLocalizedPath, ifArabic } from "@/utils/language";
import { useTranslation } from "react-i18next";
import { useLanguage } from "@/app/[lang]/client/language-context";

const slider_options: SwiperOptions = {
  slidesPerView: 3,
  spaceBetween: 30,
  loop: true,
  pagination: {
    el: ".tp-program-dot",
    clickable: true,
  },
  breakpoints: {
    "1200": {
      slidesPerView: 3,
    },
    "992": {
      slidesPerView: 3,
    },
    "768": {
      slidesPerView: 2,
    },
    "576": {
      slidesPerView: 1,
    },
    "0": {
      slidesPerView: 1,
    },
  },
};

export default function ProgramSlider() {
  const { t } = useTranslation();
  const { language } = useLanguage();

  return (
    <Swiper
      {...slider_options}
      modules={[Pagination]}
      className="swiper tp-program-active wow fadeInUp"
      data-wow-delay=".6s"
      style={{ userSelect: "none" }}
    >
      {university_classic_program_data.map((item) => (
        <SwiperSlide
          key={item.id}
          className="tp-program-item white-bg mb-30"
          style={{ direction: ifArabic("rtl ", "ltr") }}
        >
          <div className="tp-program-thumb fix">
            <Link
              aria-label="Image"
              href={getLocalizedPath(item.href ?? "", language)}
            >
              <Image
                src={item.img}
                alt={ifArabic(item.altAr, item.alt)}
                width={350}
                height={198}
                style={{ height: "auto" }}
              />
            </Link>
          </div>
          <div className="tp-program-content">
            <h3 className="tp-program-title">
              <Link
                aria-label={item.title}
                href={getLocalizedPath(item.href ?? "", language)}
              >
                {ifArabic(item.titleAr, item.title)}
              </Link>
            </h3>
            <p
              dangerouslySetInnerHTML={{
                __html: ifArabic(item.descriptionAr, item.description),
              }}
            ></p>
          </div>
          <div className="tp-program-btn">
            <Link
              aria-label="Explore Programs"
              href={getLocalizedPath(item.href ?? "", language)}
            >
              {t("explore_programs")}
            </Link>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
